import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanPhaseIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import MemoryContext from "../../../../util/MemoryContext";


class ProjectPlanPhaseEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhase-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhase-001";

        let fk = {};
        fk["ProjectPlanUSID"] = foreignKey;

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plan_phases",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
                "USID": this.getAttributeValue("USID"),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhase-002";
        payload.ShifamedMessage.ProjectPlanPhase = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/project_plan_phases",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhase-002",
                "idoc-response": "v1.ProjectPlanPhase-002",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ProjectPlanPhaseIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let projectPlanPhase = {};

        projectPlanPhase["USID"] = this.getAttributeValue("USID");
        projectPlanPhase["Name"] = this.getAttributeValue("Name");
        projectPlanPhase["Description"] = this.getAttributeValue("Description");
        projectPlanPhase["ProjectPlanUSID"] = MemoryContext.components["ProjectPlanDetail-EO-ProjectPlanUSID"];
        projectPlanPhase["StartDatetime"] = this.getAttributeValue("StartDatetime");
        projectPlanPhase["DueDatetime"] = this.getAttributeValue("DueDatetime");
        projectPlanPhase["Status"] = null;
        projectPlanPhase["Notes"] = this.getAttributeValue("Notes");
        projectPlanPhase["Justification"] = this.getAttributeValue("Justification");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhase-002";
        payload.ShifamedMessage.ProjectPlanPhase = projectPlanPhase;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/project_plan_phases",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhase-002",
                "idoc-response": "v1.ProjectPlanPhase-002",
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanPhaseIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhase-001";
        payload.ShifamedMessage.ProjectPlanPhase = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t3/v1/project_plan_phases",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhase-001",
                "idoc-response": "v1.ProjectPlanPhase-001",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanPhaseEnterpriseComponent;